module.exports = __webpack_public_path__ + "img/Group 4098.8e9444fe.png";